"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalES = void 0;
var legalESshort_cms_1 = require("./legalESshort.cms");
var LegalES = /** @class */ (function () {
    function LegalES() {
        this.legalModalPath = [
            '/idpassets/fragment/legal/prod/legalmodal/offers/wireline/checkout/expressshippinglm.cmsfeed.js',
        ];
        this.legalShortPath = new legalESshort_cms_1.LegalESShort();
    }
    return LegalES;
}());
exports.LegalES = LegalES;
//# sourceMappingURL=legalES.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/DeliveryInfoWLS/legalES.cms.js
// module id = 1989
// module chunks = 8